<template>
    <!-- ContactSearchItem.vue -->
    <base-search-item :to="contactUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {CONTACT_ICON} from '@/store/static/base-icons'
    import {CONTACT} from '@/router/contact/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'ContactSearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The icon of the list item
             */
            icon: {
                type: String,
                default: CONTACT_ICON
            }
        },
        computed: {
            contactUrl () {
                const vm = this
                return {
                    name: CONTACT,
                    params: {
                        contactId: vm.item.id
                    }
                }
            }
        }
    }
</script>
